"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CompoundButton = _interopRequireDefault(require("../CompoundButton"));
var _reactCsv = require("react-csv");
var _styled = require("./styled");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const DownloadButton = _ref => {
  let {
    caption = 'Download',
    danger = false,
    data = [],
    disabled = false,
    headers = [],
    icon = 'download',
    iconPosition = 'left',
    fileName = 'Descarga',
    fontSize = '14px',
    margin,
    separator,
    size = 30
  } = _ref;
  const csvRef = (0, _react.useRef)();
  const handleClick = () => {
    var _csvRef$current;
    if (!(csvRef !== null && csvRef !== void 0 && (_csvRef$current = csvRef.current) !== null && _csvRef$current !== void 0 && _csvRef$current.link)) return;
    csvRef.current.link.click();
  };
  const buttonProps = {
    caption,
    danger,
    disabled: disabled || (0, _isEmpty.default)(data),
    fontSize,
    icon,
    iconPosition,
    margin,
    onClick: handleClick,
    size
  };
  const downloadProps = {
    data,
    filename: "".concat(fileName, ".csv"),
    headers,
    separator,
    target: '_blank'
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_CompoundButton.default, _objectSpread({}, buttonProps)), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.HiddenContainer, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactCsv.CSVLink, _objectSpread(_objectSpread({}, downloadProps), {}, {
        ref: csvRef
      }))
    })]
  });
};
DownloadButton.propTypes = {
  caption: _propTypes.default.string,
  danger: _propTypes.default.bool,
  data: _propTypes.default.array,
  disabled: _propTypes.default.bool,
  fileName: _propTypes.default.string,
  fontSize: _propTypes.default.string,
  headers: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
  })),
  icon: _propTypes.default.string,
  iconPosition: _propTypes.default.oneOf(['left', 'right']),
  margin: _propTypes.default.string,
  onClick: _propTypes.default.func,
  separator: _propTypes.default.string,
  size: _propTypes.default.number
};
var _default = exports.default = DownloadButton;